import { MEMBER_AGE_CATEGORIES } from "../constants";

export const memberAgeCategory = (thisYear: number, yearOfBirth: number | null) => {
  if (!yearOfBirth) return MEMBER_AGE_CATEGORIES.ADULT
  const age = thisYear - yearOfBirth
  if (age <= 2) return MEMBER_AGE_CATEGORIES.BABY
  if (age > 2 && age <= 18) return MEMBER_AGE_CATEGORIES.CHILD
  return MEMBER_AGE_CATEGORIES.ADULT
}